import React from "react";
import { useSelector } from 'react-redux';
import SVG from "react-inlinesvg";

import Modal from "@app/components/ui/modals/Modal";
import cupIcon from '@src/images/landing/cup';
import medalIcon from '@icons/reward/medal'
import certificateIcon from '@icons/reward/certificate'

const ScoringPopup = ({ modal, onClose }) => {
  const olympiad = useSelector(state => {
    const { global: { olympiads } } = state;
    return olympiads[0];
  });

  const achievementThreshold = olympiad?.diploma_score ?? 61;
  const meritThreshold = olympiad?.charter_score ?? 31;

  return (
    <Modal ref={modal} className="about-certificates-modal" closeButton={false}>
      <div className="about-certificates-modal__inner">
        <h2 className="about-certificates-modal__header">Certificates for Teachers</h2>
        <p className="about-certificates-modal__description">
          Teachers receive a certificate of appreciation if at least 1 student takes part in the Olympiad.
        </p>
        <h2 className="about-certificates-modal__header">Certificates for Students</h2>
        <div className="about-certificates-modal__list">
          <div className="about-certificates-modal__item">
            <SVG src={cupIcon} />
            <span className="about-certificates-modal__label">
              <strong>Achievement:</strong> {achievementThreshold}+ points
            </span>
          </div>
          <div className="about-certificates-modal__item">
            <SVG src={medalIcon} />
            <span className="about-certificates-modal__label">
              <strong>Merit:</strong> {meritThreshold}–{achievementThreshold-1} points
            </span>
          </div>
          <div className="about-certificates-modal__item">
            <SVG src={certificateIcon} />
            <span className="about-certificates-modal__label">
              <strong>Participation:</strong> {meritThreshold-1} or fewer
            </span>
          </div>
        </div>
        <div className="modal-content__buttons w-flex-layout w-flex-layout--columns mb-0">
          <button className="btn btn--blue btn--md mb-0" onClick={onClose}>
            OK
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default ScoringPopup;
